<template>
  <div
    ref="hero"
    class="dual-hero relative"
    :class="{ 'dual-hero--transitioning': transitioning, 'dual-hero--switching': switching, 'dual-hero--switched': switched, 'dual-hero--transitioning-back': transitioningBack }"
  >
    <slot />
    <button
      class="dual-hero__cta absolute hidden md:flex"
      :aria-label="ctaText"
      @click="slide"
    >
      <ArrowLeft />
    </button>

    <button
      class="dual-hero__cta md:hidden flex justify-center text-center items-center absolute top-0"
      :class="[ctaColor]"
      @click="switchHero"
    >
      {{ ctaText }}
    </button>
  </div>
</template>

<script>

import ArrowLeft from '../icons/arrow-left'
export default {
  components: {
    ArrowLeft,
  },
  props: {
    initialCtaText: {
      type: String,
      default: null
    },
    secondaryCtaText: {
      type: String,
      default: null
    },
    initialCtaColor: {
      type: String,
      default: null
    },
    secondaryCtaColor: {
      type: String,
      default: null
    },
    sectionId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      transitioningBack: false,
      transitioning: false,
      switching: false,
      switched: false
    }
  },
  computed: {
    ctaText () {
      return this.switched ? this.secondaryCtaText : this.initialCtaText
    },
    ctaColor () {
      return 'btn' + (this.switched ? this.secondaryCtaColor : this.initialCtaColor)
    }
  },
  methods: {
    slide () {
      if (!this.switched) {
        this.transitioning = true
        setTimeout(() => {
          this.switching = true
          setTimeout(() => this.switched = true, 100)
        }, 900)
      } else {
        this.transitioningBack = true
        this.switched = false
        setTimeout(() => {
          this.switching = false
          setTimeout(() => {
            this.transitioning = false
            setTimeout(() => this.transitioningBack = false, 450)
          }, 100)
        }, 900)
      }
    },

    switchHero () {
      const mainBanner = document.querySelector(`#shopify-section-${this.sectionId} .dual-hero__block--main`)
      const secondaryBanner = document.querySelector(`#shopify-section-${this.sectionId} .dual-hero__block--secondary`)
      mainBanner.classList.remove('dual-hero__block--main')
      mainBanner.classList.add('dual-hero__block--secondary')

      secondaryBanner.classList.add('dual-hero__block--main')
      secondaryBanner.classList.remove('dual-hero__block--secondary')

      this.switched = !this.switched
    }
  },
}
</script>
